import { Component, DestroyRef, OnInit } from '@angular/core';
import { API, ProductFullDTO } from '../../../services/api/api';
import { ActivatedRoute } from '@angular/router';
import { UtilService } from '../../../services/util.service';
import { ErrorService } from '../../../services/error.service';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '@ngx-seatback/utils';
import { PermissionService } from '../../../services/permission.service';
import { finalize, take } from 'rxjs/operators';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'sb-page-product-details',
  templateUrl: './product-details.component.html',
  styleUrls: ['./product-details.component.scss'],
  standalone: false,
})
export class ProductDetailsComponent implements OnInit {
  private productId: number;
  public product: ProductFullDTO;
  loading: boolean;

  constructor(
    private api: API,
    private activatedRoute: ActivatedRoute,
    public util: UtilService,
    public errorHandler: ErrorService,
    public translate: TranslateService,
    private navService: NavigationService,
    public permissionService: PermissionService,
    private destroyRef: DestroyRef
  ) {
    this.product = null;
    this.productId = null;
    this.loading = true;
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe(params => {
      this.productId = +params.productID;
      this.refresh();
    });
  }

  refresh() {
    this.loading = true;
    this.api
      .pm_Product_retrieveById(this.productId)
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        take(1),
        finalize(() => {
          this.loading = false;
        })
      )
      .subscribe({
        next: (e: ProductFullDTO) => {
          this.product = e;
        },
        error: error => {
          if (error.status && (+error.status === 403 || +error.status === 404)) {
            this.navService.navigateToPoint(this.util.RoutingID.products);
          } else {
            this.errorHandler.errorHandler(error);
          }
        },
      });
  }
}
